import { Component } from '@angular/core';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-you-developer',
  imports: [TranslatePipe],
  templateUrl: './you-developer.html',
  styleUrl: './you-developer.scss',
})
export class YouDeveloper {}
